import { render, staticRenderFns } from "./SupervisorModal.vue?vue&type=template&id=1d135db2"
import script from "./SupervisorModal.vue?vue&type=script&lang=js"
export * from "./SupervisorModal.vue?vue&type=script&lang=js"
import style0 from "./SupervisorModal.vue?vue&type=style&index=0&id=1d135db2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports